import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import {observer, inject} from 'mobx-react'
import * as styles from './style/index.scss'
import DeviceItem from '@componentsG/deviceItem'
import {deepClone} from '@src/utils';
import NoInfo from '@componentsG/noInfo'

@inject('myDeviceStoreG')
@observer
class MyDevice extends ComponentExt<any> {
    private store: any

    constructor(props) {
        super(props)
        this.store = props.myDeviceStoreG
    }

    async componentDidMount() {
        this.showLoading()
        await this.store.getDeviceList()
        this.hideLoading()
    }

    render() {
        const deviceList = deepClone(this.store.deviceList) || []
        return (
            <div className={styles.deviceWrap}>
                {
                    deviceList.length === 0 ?
                        <NoInfo
                            messageId="device.noInfo.message"
                            btnTextMessageId="device.noInfo.btnText"
                            handleClick={() => this.goToPath('/global/bind-simCard')}
                        /> :
                        <>
                            {
                                deviceList.map(item => (
                                    <DeviceItem
                                        key={item.simId}
                                        dto={item}
                                        switchDevice={this.store.switchDevice}
                                        editNickName={this.store.editNickName}
                                    />
                                ))
                            }
                        </>
                }
            </div>
        )
    }
}
export default MyDevice
